export const ISquareResource = {
  id: 3,
  type: 'square-progress',
  json_data: { step: 'this is progress1' },
  last_user_id: 32,
  created_at: '2023-12-11T13:11:55.309Z',
  updated_at: '2023-12-12T06:30:13.125Z',
}

export const ILocations = {
  id: 5,
  store_id: 0,
  location_name: 'Default Test Account',
  location_square_id: 'LFMKJ4Q4BAZTM',
  status: 'ACTIVE',
  json_data: {
    id: 'LFMKJ4Q4BAZTM',
    name: 'Default Test Account',
    address: {
      addressLine1: '10 Downing St',
      locality: 'London',
      postalCode: 'SW1A 2AA',
      country: 'GB',
    },
    timezone: 'UTC',
    capabilities: ['CREDIT_CARD_PROCESSING', 'AUTOMATIC_TRANSFERS'],
    status: 'ACTIVE',
    createdAt: '2023-06-27T18:21:20.451Z',
    merchantId: 'MLA3D9RPDY2DC',
    country: 'GB',
    languageCode: 'en-GB',
    currency: 'GBP',
    businessName: 'Default Test Account',
    type: 'PHYSICAL',
    businessHours: {},
    mcc: '7299',
  },
  last_user_id: 0,
  created_at: '2023-10-22T21:45:14.660Z',
  updated_at: '2023-10-22T21:45:14.660Z',
  is_archive: false,
  archived_at: null,
}
